@if (isHandset()) {
  <nav class="bottom-nav" aria-label="Main Navigation">
    <div class="bottom-nav-items">
      @for (item of visibleItems; track item.id) {
        <button
          class="bottom-nav-item"
          [class.active]="isActive(item)"
          (click)="onItemClick(item)"
          [attr.aria-label]="item.labelKey | translate">
          <div class="icon-wrap">
            <mat-icon class="bottom-nav-icon">{{ item.icon }}</mat-icon>
            @if (item.badge && item.badge() > 0) {
              <span class="nav-badge">{{ item.badge() }}</span>
            }
          </div>
          <span class="bottom-nav-label">{{ item.labelKey | translate }}</span>
        </button>
      }
    </div>
  </nav>
}
